import DetailArrArea from "./det_arr";

function StudySortListArea(props: any) {
  let myProps = {
    Style: {},
    study_sort_arr: [],
    study_sort_det_arr: [],
    word_pre_info: null,
    ...props
  };
  let Style = myProps.Style;
  let study_sort_arr = myProps.study_sort_arr;
  let study_sort_det_arr = myProps.study_sort_det_arr;
  let word_pre_info = myProps.word_pre_info;

  const get_sort_tags = () => {
    let sort_tags = study_sort_arr.map((item: any, idx: number) => {
      let row_study_sort_det_arr = [];
      for (let i = 0; i < study_sort_det_arr.length; i++) {
        if (study_sort_det_arr[i].sort) {
          if (study_sort_det_arr[i].sort == item.value) {
            row_study_sort_det_arr.push(study_sort_det_arr[i]);
          }
        }
      }
      return (
        <div key={idx} className={Style.study_sort_category}>
          <div>
            <table className={Style.study_sort_table}>
              <colgroup>
                <col width={"100px"}></col>
                <col width={"80px"}></col>
                <col width={"80px"}></col>
                <col width={"70px"}></col>
                <col width={"70px"}></col>
              </colgroup>
              <tbody>
                <tr>
                  <th>{item.text}</th>
                  <th>Time</th>
                  <th>last</th>
                  <th>%</th>
                  <th>갯수</th>
                </tr>
                <DetailArrArea
                  Style={Style}
                  study_sort_det_arr={row_study_sort_det_arr}
                  word_pre_info={word_pre_info}
                ></DetailArrArea>
              </tbody>
            </table>
          </div>
        </div>
      );
    });

    return sort_tags;
  };

  return (
    <div>
      {get_sort_tags()}
    </div>
  );
};
export default StudySortListArea;